import React, { useState, useEffect } from "react";
import GoogleIcon from '@mui/icons-material/Google';
import { authActions } from "../../../redux-store";
import { ToastContainer, toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import backend from "../../../api";
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { motion, easeOut, AnimatePresence } from 'framer-motion';
import Classes from '../Signup/Auth.module.css'

const LoadingSpinner = () => (
  <div className="loadingio-spinner-eclipse-nq4q5u6dq7r">
    <div className="ldio-x2uulkbinbj">
      <div></div>
    </div>
  </div>
)

export default function Login() {
  const [width, setWidth] = useState(window.innerWidth);
  const [state, setState] = useState("signin");
  const { user } = useSelector((state) => state.auth);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [incorrectError, setincorrectError] = useState(false);
  const [showEye, setshowEye] = useState(false);

  const [passwordMatchingError, setpasswordMatchingError] = useState(false);
  const [invalidEmailError, setInvalidEmailError] = useState(false);
  const [passwordLengthError, setpasswordLengthError] = useState(false);
  const [userAlreadyExistError, setUserAlreadyExistError] = useState(false);

  // NEW: track email-sent state for forgot password
  const [emailSentMsg, setEmailSentMsg] = useState(false);

  const dispatch = useDispatch();
  const navigateTo = useNavigate();

  const loginSubmitHandler = async (e) => {
    e.preventDefault();
    setincorrectError(false);
    setLoading(true);
    const sideBar = sessionStorage.getItem('navBtn');

    const LoginData = await dispatch(authActions.login(email, password));

    if (LoginData) {
      setLoading(false);
      if (LoginData.role === 'customer' || LoginData.invitedBy === "customer") {
        navigateTo("/products");
      }
      if (LoginData.role === 'manufacturer' || LoginData.invitedBy === "manufacturer") {
        navigateTo("/listings");
      }
    } else {
      setLoading(false);
      setincorrectError(true);
    }
  };

  // ✅ Forgot password handler integrated
  const ForgotHandler = async (e) => {
    e.preventDefault();
    setincorrectError(false);
    setUserAlreadyExistError(false);
    setEmailSentMsg(false);
    setInvalidEmailError(false);

    if (!email.trim()) {
      setInvalidEmailError(true);
      return;
    }

    setLoading(true);
    try {
      // Base URL for reset – backend / action can append token etc.
      const resetBaseUrl = `${window.location.origin}/createpassword`;

      // If your action only needs email, just do:
      // const isForgot = await dispatch(authActions.forgotPassword(email));
      const isForgot = await dispatch(authActions.forgotPassword(email, resetBaseUrl));

      if (isForgot) {
        setLoading(false);
        setInvalidEmailError(false);
        setEmailSentMsg(true);
        setTimeout(() => {
          setInvalidEmailError(false);
          setEmailSentMsg(false);
        }, 10000);
      } else {
        setLoading(false);
        setEmailSentMsg(false);
        setInvalidEmailError(true);
        setTimeout(() => {
          setInvalidEmailError(false);
          setEmailSentMsg(false);
        }, 10000);
      }
    } catch (err) {
      console.error('Network error:', err);
      setLoading(false);
      setInvalidEmailError(true);
      setTimeout(() => {
        setInvalidEmailError(false);
      }, 10000);
    }
  };

  return (
    <>
      <div className={Classes.signUp} >
        <div className={Classes.signUpGridLeft} >
          <AnimatePresence mode="wait">
            {state === "signin" && (
              <motion.div
                key="signIn"
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{
                  duration: 0.3,
                  ease: easeOut,
                }}
              >
                <form className={Classes.signUpInnerCon} onSubmit={loginSubmitHandler} >
                  <div onClick={() => { navigateTo('/') }} className={Classes.miniLogo2} style={{ textDecoration: 'none', cursor: 'pointer' }} >
                    <div className='logo' >
                      <img src='/assets/images/logo.png' alt='logo' />
                    </div>
                  </div>
                  <h5 className={Classes.heading2} >Welcome back</h5>
                  <p className={Classes.subtitle} style={{ textAlign: 'start' }} >
                    Sign in to your LightTrack account to upload, organize, and manage all your lighting fixtures in one place
                  </p>
                  <input
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    placeholder="Enter your email"
                    required
                    className={`${`${Classes.inputField} ${Classes.mb20}`} ${incorrectError || userAlreadyExistError ? Classes.inputError : ''}`}
                    style={{ width: '100%' }}
                  />
                  <div className={`${`${Classes.passwordCon} ${Classes.mb20}`} ${incorrectError || passwordMatchingError || passwordLengthError ? Classes.inputError : ''}`} >
                    <input
                      onChange={(e) => setPassword(e.target.value)}
                      type={showEye ? "text" : "password"}
                      placeholder="Enter your password"
                      required
                    />
                    {showEye ?
                      <>
                        <svg onClick={() => { setshowEye(!showEye) }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z" /></svg>
                      </>
                      :
                      <>
                        <svg onClick={() => { setshowEye(!showEye) }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm51.3 163.3l-41.9-33C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5zm-88-69.3L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8z" /></svg>
                      </>
                    }
                  </div>
                  {incorrectError && <p className={Classes.error}>*Username or Password is incorrect</p>}
                  <div className={Classes.flexBetween} >
                    <div className={Classes.flexAlign} ></div>
                    <button type="button" onClick={() => setState('forgot')} className={Classes.forgotPasswordButton}>
                      Forgot password?
                    </button>
                  </div>
                  <button type="submit" className={`${Classes.button} ${Classes.signInButton}`} disabled={loading}>
                    Sign in
                    {loading && <LoadingSpinner />}
                  </button>
                  <p className={Classes.signupLink2}>
                    Don't have an account?
                    <button type="button" onClick={() => { navigateTo('/signup/customer') }} className={Classes.linkButton}>
                      Sign up
                    </button>
                  </p>
                </form>
              </motion.div>
            )}
            {state === "forgot" && (
              <motion.div
                key="forgot"
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{
                  duration: 0.3,
                  ease: easeOut,
                }}
              >
                <form className={Classes.signUpInnerCon} onSubmit={ForgotHandler}>
                  <div onClick={() => { navigateTo('/') }} className={Classes.miniLogo2} style={{ textDecoration: 'none', cursor: 'pointer' }} >
                    <div className='logo' >
                      <img src='/assets/images/logo.png' alt='logo' />
                    </div>
                  </div>
                  <h5 className={Classes.heading2} >Forgot Password</h5>
                  <p className={Classes.subtitle} style={{ textAlign: 'start' }} >
                    Enter your registered email address and we'll send you a password reset link.
                  </p>
                  <input
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    placeholder="Enter your email"
                    required
                    className={`${`${Classes.inputField} ${Classes.mb20}`} ${invalidEmailError ? Classes.inputError : ''}`}
                    style={{ width: '100%' }}
                  />
                  {invalidEmailError && <p className={Classes.error}>*Enter a valid registered email.</p>}
                  {emailSentMsg && (
                    <p style={{ color: "#16a34a", fontSize: 13, marginBottom: 8 }}>
                      Reset link has been sent to your email.
                    </p>
                  )}
                  <button type="submit" className={`${Classes.button} ${Classes.signInButton}`} disabled={loading} >
                    Continue
                    {loading && <LoadingSpinner />}
                  </button>
                  <p onClick={() => setState("signin")} className={Classes.signupLink2} style={{ cursor: 'pointer' }} >
                    Back to sign in page
                  </p>
                </form>
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            duration: 0.3,
            ease: easeOut,
          }}
          className={Classes.signUpGridRight}
        >
          <motion.div
            initial={{ opacity: 0, x: 10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{
              duration: 0.5,
              ease: easeOut,
              delay: 0.3
            }}
            className={Classes.signUpInnerCon2}
          >
            <h5 className={Classes.title3} > Simplifying Lighting Specs for <br /> Real-World Projects </h5>
            <br />
            <div className={Classes.infoElem} >
              <div className={Classes.infoImgBox} >
                <img src="/assets/icons/signin1.png" draggable={false} />
              </div>
              <div className={Classes.infoElemRight} >
                <h5 className={Classes.title5} >
                  Powerful Fixture Search
                </h5>
                <h5 className={Classes.miniText2} >
                  Instantly filter lighting products by specs like beam angle, wattage, and color temp.
                </h5>
              </div>
            </div>
            <div className={Classes.infoElem} >
              <div className={Classes.infoImgBox} >
                <img src="/assets/icons/signin2.png" draggable={false} />
              </div>
              <div className={Classes.infoElemRight} >
                <h5 className={Classes.title5} >
                  Export-Ready Output
                </h5>
                <h5 className={Classes.miniText2} >
                  Download spec sheets or Excel files formatted for documentation and team sharing.
                </h5>
              </div>
            </div>
            <div className={Classes.infoElem} >
              <div className={Classes.infoImgBox} >
                <img src="/assets/icons/signin3.png" draggable={false} />
              </div>
              <div className={Classes.infoElemRight} >
                <h5 className={Classes.title5} >
                  Organized Project Lists
                </h5>
                <h5 className={Classes.miniText2} >
                  Save selected fixtures to custom lists and manage them across multiple  projects on your account.
                </h5>
              </div>
            </div>
            <div className={Classes.infoElem} >
              <div className={Classes.infoImgBox} >
                <img src="/assets/icons/signin4.png" draggable={false} />
              </div>
              <div className={Classes.infoElemRight} >
                <h5 className={Classes.title5} >
                  Clean, Modern UI
                </h5>
                <h5 className={Classes.miniText2} >
                  Work faster with an intuitive, distraction-free interface that puts lighting specs front and center—no clutter, just clarity.
                </h5>
              </div>
            </div>
          </motion.div>
          <img
            src="/assets/images/auth-bg.png"
            alt=""
            aria-hidden="true"
            className={Classes.authBg}
            draggable={false}
          />
        </motion.div>
      </div>
    </>
  );
}
